import React, { useEffect } from "react";
import BodyMain from "../../components/util/BodyMain";
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

const HomeAuth = () => {
    const {userLogged, isFullProfile} = useSelector( state => state.userLogged);
    
    //TRANSLATION
    const [t, i18n] = useTranslation("global");

    return(
        <>
            <BodyMain>
                <p>{t("homeAuth.message")}<b>{userLogged.name}</b></p>
                
                <div style={{width:'100%', display:'flex', justifyContent:'center'}}>
                    <div style={{
                        marginTop:'70px', 
                        padding:'20px', 
                        border:'1px solid #667',
                        width:'80%',
                        color:'red',
                        textAlign:'center'
                    }}>
                        {t("util.indexMessage")}
                    </div>
                </div>
            </BodyMain>
        </>
    );
};

export default HomeAuth;